<ion-header>
  <ion-toolbar>
    <ion-title>Create Campaign</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="form">
    <ion-list>
      <ion-item>
        <ion-input formControlName="title" type="text" label="Title" labelPlacement="floating"></ion-input>
      </ion-item>

      <ion-item>
        <ion-input formControlName="url" type="text" label="URL" labelPlacement="floating"></ion-input>
      </ion-item>

      <ion-item lines="none">
        <ion-textarea 
          formControlName="description" 
          type="text" 
          label="Description" 
          labelPlacement="floating"
          [counter]="true"
          maxlength="320">
        </ion-textarea>
      </ion-item>
    </ion-list>
  </form>

</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button 
      class="ion-margin" 
      (click)="submitForm()" 
      expand="block" 
      color="secondary">
      Create
    </ion-button>  
  </ion-toolbar>
</ion-footer>